import { Form } from 'antd';
import React from 'react';
import CashierActionButton from '../components/CashierActionButton';
import { IUICashierFormValues } from '../cashier.interface';
import { useAppDispatch } from 'store/hooks';
import cashierService from 'modules/POS/services';
type Props = {
  value?: IUICashierFormValues['items'];
  onChange?: (value: IUICashierFormValues['items']) => void;
};
const CashierClearTicket = ({ onChange = () => undefined }: Props) => {
  const form = Form.useFormInstance();
  const dispatch = useAppDispatch();
  const onClearTicket = () => {
    onChange([]);
    dispatch(cashierService.actions.setActiveItemLatest(''));
    form.setFieldsValue({
      discount: 0,
    });
  };

  return (
    <CashierActionButton
      type='CLEAR_TICKET'
      onClick={onClearTicket}
    />
  );
};

export default CashierClearTicket;
